module.exports = __webpack_public_path__ + "static/media/logo_white_bg.0c66b9ad.jpg";